module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-49bf8948.png";